import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=4eed37d7"
import script from "./OrderItem.ts?vue&type=script&lang=ts&external"
export * from "./OrderItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports